<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="WKSMenSuoFiles/selectToList"
        @select="selectHandle"
        @select-all="selectHandle">
      >
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.pcOrder" clearable type="textarea"/>
          </vm-search>
        </div>
      </template>
      <div slot="toolbar">
        <el-upload
            :action="uploadUrl"
            :headers="uploadHeaders"
            :before-upload="beforeAvatarUpload"
            :disabled="disabled"
            :on-error="handlerError"
            :on-exceed="onExceed"
            :on-progress="onProgress"
            :on-success="handleSuccess"
            :show-file-list="false"
            accept=".xlsx"
            style="display: inline-block;margin: 0 5px">
          <el-button :loading="importLoading" icon="el-icon-upload2" type="success">导入</el-button>
        </el-upload>
        <el-button type="primary" :loading="exportLoading" :disabled="!selection.length" @click="exportExcel()">导出</el-button>
      </div>
      <el-table-column type="selection" align="center" width="50"/>
      <el-table-column prop="techParamBillNO" align="center" label="出厂编号"/>
      <el-table-column prop="sapMaterialDesc" align="center" label="产品名称"/>
      <!--      <el-table-column prop="specification" align="center" label="型号"/>-->
      <!--      <el-table-column prop="supplierName" align="center" label="供应商名称"/>-->
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import constant from "@/util/constant";
  import loginUtil from "@/util/loginUtil";
  import VmSearch from "@/components/VmSearch";

  export default {
    name: "WKSMenSuoToDoList",
    components: { VmTable,VmSearch},
    data() {
      return {
        constant,
        importLoading: false,
        exportLoading: false,
        disabled: false,
        uploadUrl: window.config.basicServerUrl + "WKSMenSuoFiles/importFile",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        show: "",
        filter: {
          pcOrder:"",
        },
        selection:[],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      //导入
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
      //导出
      exportExcel() {
        if (!this.selection.length) {
          this.$message.error("请先选择数据");
        }
        this.exportLoading = true;
        this.$http
          .postForFile("basic","WKSMenSuoFiles/export", this.selection)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      selectHandle(selection) {
        this.selection = selection;
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
